import { render, staticRenderFns } from "./LocaleHandler.vue?vue&type=template&id=09eb4185"
import script from "./LocaleHandler.vue?vue&type=script&lang=ts"
export * from "./LocaleHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports